import { screens } from '../../../../config/breakpoints';

const tabletWidth = screens.tablet.replace(/[^\d.-]/g, '');

const initHeader = () => {
  const header = document.querySelector('.header');
  if (header) {
    const burgerButton = header.querySelector('.header-top-line-burger-menu');
    const closeIcon = burgerButton.querySelector('.avanti-icon-cancel');
    const burgerIcon = burgerButton.querySelector('.avanti-icon-burger');
    const headerMenu = header.querySelector('.header-menu-mobile');
    burgerButton.addEventListener('click', () => {
      if (headerMenu.classList.contains('open')) {
        headerMenu.classList.remove('open');
        closeIcon.classList.remove('active');
        burgerIcon.classList.add('active');
      } else {
        burgerIcon.classList.remove('active');
        closeIcon.classList.add('active');
        headerMenu.classList.add('open');
      }
    });
  }
};

const mql = window.matchMedia(`(max-width: ${tabletWidth}px)`);

mql.onchange = e => {
  initHeader();
};

document.addEventListener('DOMContentLoaded', initHeader);
